export const projects = [
    {
      id: "1",
      title: "Fitness-Pro",
      description: "AI-powered medicine recommendation system",
      category: "AI+web",
      image: "https://i.postimg.cc/dVVVLwBw/Screenshot-2025-01-11-003741.png",
      technologies: ["React.js", "Rest-Api", "Gemini-Api", "Node.js"],
      demoUrl: "https://fitnesspro-91.vercel.app/",
      githubUrl: "https://github.com/Digvijay2347/FitnessPro",
      details:
        "An advanced medicine recommendation system that uses artificial intelligence to suggest appropriate medications based on symptoms and medical history. The system employs machine learning algorithms to analyze patterns and provide accurate recommendations.",
        isNew: true,
    },
    {
      id: "2",
      title: "Med_Alert",
      description: "International technology news platform",
      category: "Web Development",
      image: "https://i.postimg.cc/bNsRcsYN/Leonardo-Phoenix-A-technologically-sleek-Medicine-Reminder-app-3.jpg",
      technologies: ["React", "Supabase", "Tailwind CSS","JWT","Google Auth 2.0"],
      githubUrl: "https://github.com/Digvijay2347/Med_Alert",
      details:
        "A comprehensive technology news platform that aggregates and presents the latest updates from the tech industry worldwide. Features real-time updates, categorized news sections, and personalized content recommendations.",
        isNew: false,
    },
    {
      id: "3",
      title: "Hospital Management System",
      description: "Real-time data visualization platform",
      category: "Web Development",
      image: "hms.jpg",
      technologies: ["React", "Javascript", "Rbac", "Node.js", "MongoDB", "Express.js"],
      demoUrl: "https://hms-frontend2-stks.vercel.app/",
      githubUrl: "https://github.com/Digvijay2347/HMS",
      details:
        "A powerful analytics dashboard that provides real-time insights through interactive visualizations. Includes customizable widgets, data filtering capabilities, and automated reporting features.",
    },
    {
        id: "4",
        title: "Live Tracking Web Application",
        description: "Real-time data visualization platform",
        category: "Web Development",
        image: "trs.jpg",
        technologies: ["JWT", "Leaflet", "EJS","Socket.io","Node.js","Express.js","Passport.js"],
        githubUrl: "https://github.com/Digvijay2347/Live-Tracking",
        details:
          "A powerful analytics dashboard that provides real-time insights through interactive visualizations. Includes customizable widgets, data filtering capabilities, and automated reporting features.",
      },
      {
        id: "5",
        title: "CodePlanet Pro",
        description: "Real-time data visualization platform",
        category: "Web Development",
        image: "https://i.postimg.cc/J0LXB6rK/fav.png",
        technologies: ["Html5", "Gsap", "JSON", "TailWind", "Bootstrap"],
        demoUrl: "https://digvijay2347.github.io/Codeplanetpro/",
        details:
          "A powerful analytics dashboard that provides real-time insights through interactive visualizations. Includes customizable widgets, data filtering capabilities, and automated reporting features.",
      },
    {
      id: "6",
      title: "Coming Soon",
      description: "Exciting new Mobile App project in development",
      category: "Content Creation",
      image: "https://i.postimg.cc/VkKgTJcx/Leonardo-Phoenix-10-a-breathtaking-intricately-designed-illust-0.jpg",
      technologies: [],
      details: "Stay tuned for our upcoming app dev project that will revolutionize the way you interact with your mobile device. We're working hard to bring you a cutting-edge experience that will change the way you think about mobile apps.",
      isComingSoon: true,
    },
    {
      id: "7",
      title: "B2B CRM",
      description: "Platform for managing B2B customer relationships",
      category: "E-Commerce Database",
      image: "https://i.postimg.cc/Gtb8yJ7p/Leonardo-Phoenix-10-Design-a-modern-professional-illustration-1.jpg",
      technologies: ["React", "Javascript", "Rbac", "Node.js", "MongoDB", "Express.js"],
      details: "A platform for managing B2B customer relationships, providing tools for customer management, sales tracking, and communication. ",
      githubUrl: "https://github.com/Digvijay2347/B2B-Customer-Relationship-Management-CRM-",
    },
    {
      id: "8",
      title: "NLP-VideoSummarizer",
      description: "A transformer-based model for processing YouTube transcripts",
      category: "Machine Learning",
      image: "https://i.postimg.cc/YqXHn30t/Leonardo-Phoenix-10-A-stunning-highresolution-illustration-of-3.jpg",
      technologies: ["Python", "Transformers", "Hugging Face", "Pandas", "Numpy"],
      details: "A web application that allows users to summarize YouTube videos by extracting their transcripts and generating concise summaries using natural language processing. The tool supports both command-line and web-based interfaces.",
      githubUrl: "https://github.com/Digvijay2347/TransformerBasedYTTranscriptProcessor",
    },
  ];
  
  export const categories = [
    { value: "all", label: "All Categories" },
    { value: "ai", label: "AI Projects" },
    { value: "machine", label: "Machine Learning" },
    { value: "web", label: "Web Development" },
    { value: "app", label: "Mobile App" },
    { value: "AI+web", label: "Ai + Web" },    
  ];
  
